import {
  Drawer,
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
  useDisclosure,
  Heading,
  Box,
  Text,
  Button,
  Center,
  Stack,
} from "@chakra-ui/react";
import { shortString } from "../../../utility/helper";
import { useSelector } from "react-redux";

export const DrawerComponent = ({ isOpen, onOpen, onClose, btnRef }) => {
  const address = useSelector((state) => {
    return state.userData.walletAddress;
  });
  return (
    <>
      <Drawer
        isOpen={isOpen}
        placement="left"
        onClose={onClose}
        finalFocusRef={btnRef}
      >
        <DrawerOverlay />
        <DrawerContent>
          <DrawerCloseButton />
          <DrawerHeader>
            <Text variant={"body"}>Menu</Text>
          </DrawerHeader>
          <DrawerBody>
            {address ? (
              <>
                <Box marginBottom="10px">
                  <Text variant={"body"}>Account</Text>
                  <Box>
                    <Center>
                      <Button p="10px 90px">{shortString(address, 20)}</Button>
                    </Center>
                  </Box>
                </Box>
              </>
            ) : (
              ""
            )}

            <Center>
              <Stack>
                <Button variant={"drawerMenuButton"}>
                  <Text variant={"body"}>Dashboard</Text>
                </Button>
                <Button variant={"drawerMenuButton"}>
                  <Text variant={"body"}>Event</Text>
                </Button>
                <Button variant={"drawerMenuButton"}>
                  <Text variant={"body"}>YourTickets</Text>
                </Button>
              </Stack>
            </Center>
          </DrawerBody>
          <DrawerFooter>
            <Heading>
              <Text variant={"body"}>Footer</Text>
            </Heading>
          </DrawerFooter>
        </DrawerContent>
      </Drawer>
    </>
  );
};
